import React, { useMemo, useState, useEffect, useCallback, useContext } from 'react';

import { debugLog as log } from 'shared-services/logger-service';

import { ThemeContext } from 'context/ThemeContext';

import WebexLib from 'components/WebexLib';

export const WebexContext = React.createContext();

export const WebexProvider = ({ children }) => {
    const themeCtx = useContext(ThemeContext);
    const [inApp, setInApp] = useState(Boolean(window?.webex));
    // const [inApp, setInApp] = useState(true);
    const [app, setApp] = useState(null);
    const [loaded, setLoaded] = useState(false);
    const [user, setUser] = useState(null);

    const handleLibLoad = useCallback(() => {
        const app = window.Webex?.Application();
        setApp(app);

        const webexApp = window.webex.application;

        webexApp.onReady().then(async () => {
            log('[WEBEX] Ready', app);
            const webexTheme = app.theme;

            if (webexTheme) {
                themeCtx?.setThemeOverride(webexTheme.toLowerCase());
            }

            webexApp
                .listen()
                .then(() => {
                    webexApp.on('application:themeChanged', theme => {
                        themeCtx?.setThemeOverride(theme.toLowerCase());
                    });
                });

            try {
                const user = await app.context.getUser();
                setLoaded(true);
                setUser(user);
            } catch (e) {
                console.error('[NIFTY WEBEX] User get error', e);
            }
        });
    }, []);

    const handleMessage = event => {
        if (
            event.data?.type === 'DATA' &&
            'user' in event.data?.data
        ) {
            setInApp(true);
            window.removeEventListener('message', handleMessage);
        }
    }

    const value = useMemo(() => ({
        inApp,
        app,
        user,
        loaded
    }), [inApp, app, user, loaded]);

    useEffect(() => {
        if (inApp) {
            window.inWebex = true;
            document.body.classList.add('in-webex');
        } else {
            window.inWebex = false;
            document.body.classList.remove('in-webex');
        }
    }, [inApp]);

    useEffect(() => {
        window.addEventListener('message', handleMessage);

        window.parent.postMessage({
            action: 'SEND_DATA'
          }, '*');

        return () => {
            window.removeEventListener('message', handleMessage);
        }
    }, []);

    return (
        <WebexContext.Provider value={value}>
            {
                inApp ? <WebexLib asyncScriptOnLoad={handleLibLoad} /> : null
            }

            { children }
        </WebexContext.Provider>
    )
};
